import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Collapse } from 'react-bootstrap'

import Button from '../Button'

const CollapsibleTitle = ({
  id = '',
  title,
  children,
  defaultClose = false
}) => {
  const [isOpen, toggleOpen] = useState(!defaultClose)

  return (
    <>
      <div className='pb-3'>
        <span className='d-flex align-items-center pointer' onClick={() => toggleOpen(!isOpen)}>
          {title}
          <Button ghost ariaLabel={isOpen ? 'Expand' : 'Collapse'} className='text-reset py-0 px-1 ms-3' onClick={(e) => {
            if (e.currentTarget === document.activeElement) {
              e.currentTarget.blur()
            }
          }}>
            <span className={`fa-solid fa-chevron-${isOpen ? 'down' : 'right'}`} />
          </Button>
        </span>
      </div>
      <div id={`collapsableTitle-${id}`}>
        <Collapse in={isOpen}>
          <div>
            {children}
          </div>
        </Collapse>
      </div>
    </>
  )
}

CollapsibleTitle.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  defaultClose: PropTypes.bool
}

export default CollapsibleTitle
